import { cloneDeep } from 'lodash';
import { validateEmail, isNotWorkEmail, getPasswordErrorMessage } from '@src/util/validation';
import { FormKey } from '../enums/formKey.enum';
import { FormData } from '../interfaces/formData.interface';

export const validateRegisterFormFirstStep = (formData: FormData): FormData => {
  const form = cloneDeep(formData);

  for (const key in form) {
    switch (key) {
      case FormKey.COMPANY_NAME:
      case FormKey.FULL_NAME:
        if (!form[key].value) {
          form[key] = { ...form[key], error: 'Field is required' };
          break;
        }

        if (form[key]?.error && !form[key]?.value) {
          form[key] = { ...form[key], error: 'Field is required' };
        }

        break;
      case FormKey.PASSWORD:
        if (!form[key].value) {
          form[key] = { ...form[key], error: 'Field is required' };
          break;
        }

        form[key] = { ...form[key], error: getPasswordErrorMessage(form[key].value) };

        break;
      case FormKey.WORK_EMAIL:
        if (!form[key].value) {
          form[key] = { ...form[key], error: 'Field is required' };
          break;
        }

        if (form[key] && !validateEmail(form[key].value)) {
          form[key] = { ...form[key], error: 'E-mail is not valid' };
          break;
        }

        if (form[key] && isNotWorkEmail(form[key].value)) {
          form[key] = { ...form[key], error: 'Your email should be your work email' };
          break;
        }

        break;
      default:
        break;
    }
  }

  return form;
};

export const validateRegisterFormSecondStep = (formData: FormData): FormData => {
  const form = cloneDeep(formData);

  for (const key in form) {
    switch (key) {
      case FormKey.POSITION_TITLE:
      case FormKey.PHONE_NUMBER:
      case FormKey.COMPANY_SIZE:
      case FormKey.COUNTRY:
      case FormKey.TERMS_OF_USE:
      case FormKey.SOURCE:
      case FormKey.CAPTCHA:
        if (!form[key].value) {
          form[key] = { ...form[key], error: 'Field is required' };
          break;
        }

        break;
      default:
        break;
    }
  }

  return form;
};
